module.exports = __webpack_public_path__ + "static/hazmatitems-4f0ea40aa9084d4d9c1ace1df3f6c6d5.png";